/** 48×48 pixel icons in public/icons/. Title bars scale them to 16px. */

export const icons: Record<string, string> = {
  computer: './icons/computer.png',
  recycle: './icons/recycle.png',
  folder: './icons/folder.png',
  notepad: './icons/notepad.png',
  music: './icons/music.png',
  games: './icons/games.png',
  browser: './icons/browser.png',
  about: './icons/about.png',
  wrack: './icons/wrack.png',
  bee: './icons/bee.png',
  speaker: './icons/speaker.png',
  control: './icons/control.png',
  display: './icons/display.png',
  shutdown: './icons/shutdown.png',
  videos: './icons/browser.png',
};

export function iconUrl(id: string): string {
  return icons[id] ?? icons.folder;
}
